import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { TabNav } from '../../components/nav/tabNav'
import { PageHeader } from '../../components/typography/PageHeader'
import Layout from '../../layout'
import { Affiliates } from './affiliates'
import { Ambassadors } from './ambassadors'

const pageTabs = [
  { name: 'Affiliates', id: 'Affiliates' },
  { name: 'Ambassadors', id: 'Ambassadors' },
]
export const EarningPartnersPage = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const [activeTab, setActiveTab] = useState<string>(
    searchParams.get('tab') ?? pageTabs[0].id,
  )

  return (
    <Layout>
      <div className="flex flex-col gap-10">
        <PageHeader title={`Earning Partners`} className="capitalize !my-0" />

        <TabNav
          activeTab={activeTab}
          setActiveTab={(tab) => {
            setActiveTab(tab)
            setSearchParams({
              tab: tab,
              search: '',
              page: '1',
            })
          }}
          tabs={pageTabs}
          className="!mb-0"
        />

        {activeTab === 'Affiliates' ? <Affiliates /> : undefined}
        {activeTab === 'Ambassadors' ? <Ambassadors /> : undefined}
      </div>
    </Layout>
  )
}
